(function() {
  if (window.BuddySupplementFacts) return;

  var focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function formatNumber(value) {
    return Number.isInteger(value)
      ? String(value)
      : value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  }

  function scaleServingValue(mediumValue, multiplier) {
    var match = String(mediumValue).trim().match(/^([\d,.]+)\s*(.*)$/);
    if (!match) return mediumValue;

    var number = Number(match[1].replace(/,/g, ''));
    if (!Number.isFinite(number)) return mediumValue;

    var unit = match[2].trim();
    return formatNumber(number * multiplier) + (unit ? ' ' + unit : '');
  }

  function triggersFor(popup) {
    return Array.from(document.querySelectorAll('[data-supplement-facts-trigger]')).filter(function(trigger) {
      return (trigger.getAttribute('aria-controls') || 'supplement-facts-popup') === popup.id;
    });
  }

  function setTriggerState(popup, expanded) {
    triggersFor(popup).forEach(function(trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', String(expanded));
    });
  }

  function getFocusableElements(popup) {
    return Array.from(popup.querySelectorAll(focusableSelector)).filter(function(element) {
      return element.getClientRects().length > 0;
    });
  }

  function dogSizeFromValue(value) {
    var normalizedValue = String(value || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .toLowerCase();

    if (/\bsmall\b/.test(normalizedValue)) return 'small';
    if (/\bmedium\b/.test(normalizedValue)) return 'medium';
    if (/\blarge\b/.test(normalizedValue)) return 'large';
    return null;
  }

  function selectedBuyBoxDogSize() {
    var optionGroups = Array.from(document.querySelectorAll(
      'variant-radios [data-option-slug], variant-selects [data-option-slug]'
    ));
    var dogSizeGroup = optionGroups.find(function(group) {
      var groupDescription = [
        group.dataset.optionSlug,
        group.querySelector('legend, .form__label') && group.querySelector('legend, .form__label').textContent
      ].filter(Boolean).join(' ').toLowerCase();

      return groupDescription.includes('dog') && groupDescription.includes('size');
    });

    if (dogSizeGroup) {
      var selectedControl = dogSizeGroup.querySelector('input[type="radio"]:checked, option:checked');
      var selectedSize = dogSizeFromValue(
        selectedControl && (selectedControl.dataset.optionValue || selectedControl.value || selectedControl.textContent)
      );

      if (selectedSize) return selectedSize;
    }

    var selectedPurchaseOption = document.querySelector(
      'input[data-radio-type][data-variant-option1]:checked'
    );

    return dogSizeFromValue(selectedPurchaseOption && selectedPurchaseOption.dataset.variantOption1);
  }

  function initializePopup(popup) {
    if (popup.dataset.supplementFactsInitialized === 'true') return;
    popup.dataset.supplementFactsInitialized = 'true';

    var closeButton = popup.querySelector('[data-supplement-facts-close]');
    var heading = document.getElementById(popup.getAttribute('aria-labelledby'));
    var scrollRegion = popup.querySelector('[data-supplement-facts-scroll]');
    var options = Array.from(popup.querySelectorAll('[data-dog-size-option]'));
    var servingSize = popup.querySelector('[data-serving-size]');
    var servingsPerContainer = popup.querySelector('[data-servings-per-container]');
    var servingValues = Array.from(popup.querySelectorAll('[data-serving-value]'));
    var announcement = popup.querySelector('[data-serving-announcement]');
    var lastTrigger = null;

    function updateServingFacts(option, announce) {
      if (!option) return;

      var multiplier = Number(option.dataset.multiplier);
      if (!Number.isFinite(multiplier)) multiplier = 1;

      if (servingSize) servingSize.textContent = option.dataset.servingDescription;
      if (servingsPerContainer) servingsPerContainer.textContent = option.dataset.servings;

      servingValues.forEach(function(value) {
        value.textContent = scaleServingValue(value.dataset.mediumValue, multiplier);
      });

      if (announce && announcement) {
        announcement.textContent = option.dataset.sizeLabel + ' selected. Serving size: ' +
          option.dataset.servingDescription + '. ' + option.dataset.servings +
          ' servings per container. Ingredient values updated.';
      }
    }

    function syncToBuyBoxSelection() {
      var selectedSize = selectedBuyBoxDogSize();
      var matchingOption = selectedSize && options.find(function(option) {
        return option.value === selectedSize;
      });

      if (!matchingOption) return;
      matchingOption.checked = true;
      updateServingFacts(matchingOption, false);
    }

    function open(trigger) {
      lastTrigger = trigger || document.activeElement;
      syncToBuyBoxSelection();
      popup.classList.add('open');
      popup.setAttribute('aria-hidden', 'false');
      popup.removeAttribute('inert');
      document.body.classList.add('overflow-hidden');
      setTriggerState(popup, true);
      if (scrollRegion) scrollRegion.scrollTop = 0;

      window.requestAnimationFrame(function() {
        if (heading) heading.focus({ preventScroll: true });
        else if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function close(restoreFocus) {
      popup.classList.remove('open');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('inert', '');
      setTriggerState(popup, false);

      if (!document.querySelector('[data-supplement-facts].open')) {
        document.body.classList.remove('overflow-hidden');
      }

      if (restoreFocus !== false && lastTrigger && typeof lastTrigger.focus === 'function') {
        var triggerToFocus = lastTrigger;
        var focusDelay = triggerToFocus.closest('[data-ingredients-shop-sticky]') ? 220 : 0;
        window.setTimeout(function() {
          triggerToFocus.focus({ preventScroll: true });
        }, focusDelay);
      }
    }

    popup.supplementFactsOpen = open;
    popup.supplementFactsClose = close;

    options.forEach(function(option) {
      option.addEventListener('change', function() {
        if (option.checked) updateServingFacts(option, true);
      });
    });

    closeButton && closeButton.addEventListener('click', function() {
      close(true);
    });

    popup.addEventListener('click', function(event) {
      if (event.target === popup) close(true);
    });

    popup.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements(popup);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    setTriggerState(popup, false);
    updateServingFacts(options.find(function(option) { return option.checked; }) || options[0], false);
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.from(scope.querySelectorAll('[data-supplement-facts]')).forEach(initializePopup);

    Array.from(document.querySelectorAll('[data-supplement-facts-trigger]')).forEach(function(trigger) {
      if (!trigger.getAttribute('aria-controls')) trigger.setAttribute('aria-controls', 'supplement-facts-popup');
      trigger.setAttribute('aria-haspopup', 'dialog');
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function findPopup(triggerOrId) {
    var id = typeof triggerOrId === 'string'
      ? triggerOrId
      : triggerOrId && triggerOrId.getAttribute('aria-controls');

    return document.getElementById(id || 'supplement-facts-popup') || document.querySelector('[data-supplement-facts]');
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-supplement-facts-trigger]');
    if (!trigger) return;

    var popup = findPopup(trigger);
    if (!popup) return;

    event.preventDefault();
    initializePopup(popup);
    popup.supplementFactsOpen(trigger);
  });

  window.BuddySupplementFacts = {
    initialize: initialize,
    open: function(id, trigger) {
      var popup = findPopup(id);
      if (!popup) return;
      initializePopup(popup);
      popup.supplementFactsOpen(trigger);
    },
    close: function(id) {
      var popup = findPopup(id);
      if (popup && popup.supplementFactsClose) popup.supplementFactsClose(true);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initialize(event.target);
  });
})();
